module.exports = __webpack_public_path__ + "statics/img/MultiWarehouse-1.891bb336.png";